
import axios from "axios";
import config from "@/config.json";

export function host() {
    return process.env.VUE_APP_SERVER_HOST;
}

export function webHost() {
    return process.env.VUE_APP_WEB_HOST;
}

export function avatarUrl() {
    return process.env.VUE_APP_AVATAR_URL;
}

export async function post(action, params) {

    try {
        /*
        const response = await  fetch(`${process.env.VUE_APP_SERVER_HOST}${action}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params),
            mode:'cors',
            credentials: "include"
        });
        return response.json();
         */
        const headers = {
            'Accept': 'application/json',
        };
        const accessToken = localStorage.getItem("access_token");
        if (accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        }
        const response = await axios.post(`${process.env.VUE_APP_SERVER_HOST}${action}`, params, { headers: headers });
        return response.data;
    } catch (e) {
        /*
         * 以前这里直接 return null，带来两个问题：
         *   1. 不少调用方写的是 `data.errno === 0`，null 会抛 TypeError，再被空 catch 吞掉，
         *      界面上什么都不会发生（下单失败就是这么静默的）。
         *   2. 401、429、5xx、断网全都退化成同一个 null，界面一律显示成「未登录」，
         *      排查时分不清到底是没登录还是接口挂了。
         * 现在统一返回一个错误对象：errno 非 0，所有 `errno === 0` 的判断照旧成立，
         * 同时把 HTTP 状态码带出去，调用方可以据此区分「服务端说没登录」和「请求没成功」。
         */
        const status = e.response ? e.response.status : 0;
        const body = e.response ? e.response.data : null;
        console.warn(`[api] ${action} 请求失败：HTTP ${status}`, body || e.message);
        return {
            errno: (body && typeof body.errno === 'number') ? body.errno : -1,
            http_status: status,
            info: (body && body.info) || (status ? `Request failed (HTTP ${status})` : 'Network error')
        };
    }
}
